import { render, staticRenderFns } from "./PassportInput.vue?vue&type=template&id=13ff4dc8&"
import script from "./PassportInput.vue?vue&type=script&lang=js&"
export * from "./PassportInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports